import { useHistory } from 'react-router-dom';
import { Path } from '@components/routes/constants';

/**
 * Shared hook for navigating to the plans/upgrade page.
 * usedCount by all trial container components.
 */
export const useUpgradeNavigation = () => {
  const history = useHistory();
  return () => {
    history.push(`${Path.ORGANIZATION}?tab=plans`);
  };
};
